const appendImageBlock = () => {
  const imageUrl = "https://cdn.shopify.com/s/files/1/0609/0699/5918/files/Buy_More_Save_More_Personalized.jpg?v=1761627686";
  const img = document.createElement("img");
  img.src = imageUrl;
  img.alt = "Buy More Save More";
  img.style.maxWidth = "320px";
  img.style.height = "auto";
  img.style.marginTop = "0px";
  img.style.marginBottom = "0px";

  const priceBlock = document.querySelector(".tee-product-price");
  const dynamicPrice = document.querySelector("[id*='price-template--']");
  
  if (priceBlock) {
    priceBlock.insertAdjacentElement("afterend", img);
    return;
  } else if (dynamicPrice) {
    dynamicPrice.insertAdjacentElement("afterend", img);
    return;
  }
    
}

document.addEventListener('teeinblue-event-component-injected', function() {
  const elementToMove = document.querySelector('product-info .product-form__quantity');
  const insertAfterElement = document.querySelector('.formWrapperItem product-form');
  if (elementToMove && insertAfterElement) {        
    insertAfterElement.before(elementToMove)
  }

  appendImageBlock();
});